import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';

const normalizeAssetUrl = (url) => {
  if (!url) return '';
  return url.startsWith('//') ? `https:${url}` : url;
};

const ContentfulTeamMemberCard = ({ entry, avatarSize = 150 }) => {
  const photo = entry?.fields?.photo;
  const src = normalizeAssetUrl(photo?.fields?.file?.url);
  const alt = photo?.fields?.title ?? '';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Avatar src={src} alt={alt} sx={{ width: avatarSize, height: avatarSize, mb: 2 }} />
      <Typography variant="h6">{entry?.fields?.name}</Typography>
      <Typography v>{entry?.fields?.jobTitle}</Typography>

    </Box>
  );
};

export default ContentfulTeamMemberCard;
